<template>
  <b-button
    variant="link"
    size="sm"
    class="copy-btn p-0 ml-1"
    :title="copied ? 'Copied!' : 'Copy'"
    @click.stop="copy"
  >
    <i :class="copied ? 'fas fa-check text-success' : 'fas fa-copy text-muted'" />
  </b-button>
</template>

<script>
import { BButton } from "bootstrap-vue";

export default {
  components: { BButton },
  props: {
    text: { type: String, required: true }
  },
  data() {
    return { copied: false, timer: null };
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    async copy() {
      try {
        await navigator.clipboard.writeText(this.text);
        this.copied = true;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => { this.copied = false; }, 1500);
      } catch {
        // fallback
        const ta = document.createElement("textarea");
        ta.value = this.text;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        this.copied = true;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => { this.copied = false; }, 1500);
      }
    }
  }
};
</script>

<style scoped>
.copy-btn { line-height: 1; vertical-align: baseline; }
</style>
